import {useState} from "react";
import {isNullOrUndefined} from "../../../../services/Validator";
import {PageView} from "../../../../enums/PageView";
import {useResizeListener} from "../../../../listeners/SystemResizeListener";
import {recordPageViewMetric} from "../../../../services/AnalyticsRecorder";
import FlashCorrectionScreen from "../../../../screens/courses/flash/FlashCorrectionScreen";
import SystemHorizontalStarDivider from "../../../dividers/courses/flash/SystemHorizontalStarDivider";
import FlashResultsQuestionIndex from "../../../others/courses/flash/FlashResultsQuestionIndex";
import FlashResultsQuestionItemLayout from "../../../layouts/courses/flash/FlashResultsQuestionItemLayout";
import FlashResultsQuestionItemChevronIcon from "../../../icons/courses/flash/FlashResultsQuestionItemChevronIcon";
import CoursesResultsQuestionStatementText from "../../../texts/courses/CoursesResultsQuestionStatementText";

export default function FlashResultsQuestionItem({index, total, question}) {
    // Used in ResultsQuestionsList to display one single
    // question element that leads to correction

    // PROPERTIES
    const [isCorrectionModalOpen, setIsCorrectionModalOpen] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsCorrectionModalOpen(false))

    // BUILD
    if (isNullOrUndefined(question))
        return null
    return (
        <div className="w-full flex flex-col space-y-[6px]">
            {/** CORRECTION MODAL */}
            <FlashCorrectionScreen open={isCorrectionModalOpen}
                                   handleClose={() => setIsCorrectionModalOpen(false)}
                                   question={question} />
            {/** CORE */}
            <FlashResultsQuestionItemLayout setIsHovered={setIsHovered}
                                            openModal={() => openModal()}>
                <FlashResultsQuestionIndex number={index + 1}
                                           correctness={question?.selectedOption?.isCorrect} />
                <CoursesResultsQuestionStatementText statement={question?.query}
                                                     isHovered={isHovered} />
                <FlashResultsQuestionItemChevronIcon isHovered={isHovered} />
            </FlashResultsQuestionItemLayout>
            {/** BOTTOM DIVIDER IF NECESSARY */}
            {index === (total - 1) ? null : <SystemHorizontalStarDivider />}
        </div>
    );

    // METHODS
    // ---- Open modal
    function openModal() {
        // NAV : Open modal
        setIsCorrectionModalOpen(true)
        // METRICS : Record opening
        recordPageViewMetric(PageView.CORRECTION)
    }

}